import { useRecoilValue, useSetRecoilState } from 'recoil'
import clsx from 'clsx'
import Decimal from 'decimal.js'
import PositionList from '@/components/trade/PositionList'
import { showSettlePnlPopupState, positionDetailValue } from '@/recoil/Position'
import numberFormat from '@/utils/numberFormat'

import './PositionInfo.css'

function InfoValue({ value, format = 'max2', showColor = true }) {
  const sign = Decimal(value).lt(0) ? '-' : ''
  const colorClassConfig = showColor
    ? {
        'color-positive': Decimal(value).gt(0),
        'color-negative': Decimal(value).lt(0)
      }
    : {}
  return (
    <div className={clsx('info-value', colorClassConfig)} title={value}>
      {sign}
      {numberFormat(Decimal(value).abs().toNumber(), 'max2')}
    </div>
  )
}

export default function PositionInfo({ showAllMarketData }) {
  const {
    totalPositionNotionalValue,
    totalDailyPnl,
    totalUnrealPnl,
    totalUnsettledPnl
  } = useRecoilValue(positionDetailValue)
  const setShowSettlePnlPopup = useSetRecoilState(showSettlePnlPopupState)

  const settlePnlDisabled = Decimal(totalUnsettledPnl).eq(0)

  return (
    <div className="position-info-container">
      <div className="position-info">
        <div className="info-block">
          <div className="info-title">Total unrealized P&L</div>
          <InfoValue value={totalUnrealPnl} />
        </div>
        <div className="info-block">
          <div className="info-title">Daily realized P&L</div>
          <InfoValue value={totalDailyPnl} />
        </div>
        <div className="info-block">
          <div className="info-title">Notional value</div>
          <InfoValue value={totalPositionNotionalValue} showColor={false} />
        </div>
        <div className="info-block">
          <div className="info-title">Unsettled P&L</div>
          <InfoValue value={totalUnsettledPnl} />
        </div>
        <div className="empty-fill-box" />
        <div
          className={clsx('settle-pnl-button', {
            disabled: settlePnlDisabled
          })}
          onClick={() => !settlePnlDisabled && setShowSettlePnlPopup(true)}
        >
          Settle P&L
        </div>
      </div>
      <PositionList showAllMarketData={showAllMarketData} />
    </div>
  )
}
